// removed by extract-text-webpack-plugin
module.exports = {"Resume":"Resume__Resume__w6kur","row":"Resume__row__Bg5i0","Span":"Resume__Span__28Icq","Item":"Resume__Item__129HF","SubHead":"Resume__SubHead__KlWs-","SubLower":"Resume__SubLower__OB8IC","SubPara":"Resume__SubPara__1etWZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Resume/Resume.css
// module id = 39
// module chunks = 0